import logo from './logo.svg';
import './App.css';
import {Routes,Route} from 'react-router-dom';
import TodoList from './components/TodoList';
import { createTheme,ThemeProvider } from '@mui/material';
import { useState } from 'react';
import { v4 as idv4 } from 'uuid';
import { TodoContexts } from './context/TodoContext';
const theme=createTheme({
  typography:{
    fontFamily:[
      'f'
    ]
  },
});
const initialtodos=[
  {
    id:idv4(),
    title:'قراءة كتاب',
    details:' sdhsjd من الساعة 3 العصر الى المغرب',
    isCompleted:false
  
  },
  {
    id:idv4(),
    title:'قراءة كتاب',
    details:'sss من الساعة 3 العصر الى المغرب',
    isCompleted:false
  
  },
];
function App() {
  const [todoses,settodos]=useState(initialtodos);
  return (
   <ThemeProvider theme={theme}>
  
     <div className="App" style={{ 
      display:'flex',
    justifyContent:'center',
    alignItems:'center',
    backgroundColor:'rgba(7, 45, 134, 1)',
    height:'100vh',
    
    direction:'rtl',
    
    }}>
    <TodoContexts.Provider value={{todoses,settodos}}>
      
      

   <Routes>
    <Route path='/' element={<TodoList/>}/>
   </Routes>
   </TodoContexts.Provider>    
    </div>
   </ThemeProvider>
  );
}

export default App;
